<div [matTooltip]="geographyTooltip()" matTooltipClass="e-tooltip">
    <mat-form-field>
        <mat-label>
            <span [ngClass]="{'bold-label': selectedGeographies().length > 0}">Geographies</span>
            <ng-container *ngIf="selectedGeographies().length === 1"> : {{ selectedGeographies()[0].name }}</ng-container>
            <ng-container *ngIf="selectedGeographies().length > 1"> : Multiple Selections</ng-container>
        </mat-label>
        <mat-select multiple (click)="openDialog()">
        </mat-select>
    </mat-form-field>
</div>


